module.exports = __webpack_public_path__ + "img/thread-record-icon.d3d3a944.svg";